query GetFollowUpTasksEligibility {
    loggedInUser {
        id
        isAiFollowUpTasksEnabled
        hasRecentTranscriptionSummary
    }
}
